import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'src.pages.Final.title',
    defaultMessage: 'Your claim has been successfully submitted.',
  },
  title2: {
    id: 'src.pages.Final.title2',
    defaultMessage: 'We’ve received your claim details.',
  },
  reference1: {
    id: 'src.pages.Final.reference1',
    defaultMessage: 'We’ve received your claim details. Your claim # is ',
  },
  reference2: {
    id: 'src.pages.Final.reference2',
    defaultMessage: 'We have not opened an injury claim for you at this time as it looks like you won’t be going for any treatment. We’re so glad you’re ok!',
  },
  reference3: {
    id: 'src.pages.Final.reference3',
    defaultMessage: 'We’ve opened a claim for your vehicle. Your claim # is ',
  },
  referenceNumber: {
    id: 'src.pages.Dashboard.referenceNumber',
    defaultMessage: '{referenceNumber}.',
  },
  subtitleHappenNext: {
    id: 'src.pages.Final.subtitleHappenNext',
    defaultMessage: "Here's what will happen next:",
  },
  subtitleNeedToKnow: {
    id: 'src.pages.Final.subtitleNeedToKnow',
    defaultMessage: 'Here’s what you need to know:',
  },
  happenNextLi1: {
    id: 'src.pages.Final.happenNextLi1',
    defaultMessage: 'You’ll receive an email with a PDF of the details you provided. Make sure to check your junk email if you don’t see it.',
  },
  happenNextLi2: {
    id: 'src.pages.Final.happenNextLi2',
    defaultMessage: 'Within one business day, a claims expert from Definity Insurance Company, Sonnet’s parent company, will contact you to discuss your vehicle claim.',
  },
  happenNextLi3: {
    id: 'src.pages.Final.happenNextLi3',
    defaultMessage: 'There will be no further follow up at this time regarding your injuries, but your information will be kept on file in case anything does change.',
  },
  happenNextLi4: {
    id: 'src.pages.Final.happenNextLi4',
    defaultMessage: 'If you do plan to attend treatment for your injuries, please contact us at 1-844-766-6384 to open an injury claim.',
  },
  happenNextLi5: {
    id: 'src.pages.Final.happenNextLi5',
    defaultMessage: 'You’ll receive an email with a PDF of the details you provided and next steps. Make sure to check your junk email if you don’t see it.',
  },
  happenNextLi6: {
    id: 'src.pages.Final.happenNextLi6',
    defaultMessage: 'A claims expert from Definity Insurance Company, Sonnet’s parent company, will contact you to discuss your claim.',
  },
  happenNextLi7: {
    id: 'src.pages.Final.happenNextLi7',
    defaultMessage: 'Within one business day, a claims expert from Definity Insurance Company, Sonnet’s parent company, will contact you to discuss your claim.',
  },
  happenNextLi8: {
    id: 'src.pages.Final.happenNextLi8',
    defaultMessage: 'There will be no further follow up at this time, but your information will be kept on file in case anything does change.',
  },
  subtitleRemember: {
    id: 'src.pages.Final.subtitleRemember',
    defaultMessage: 'Some things to remember:',
  },
  rememberLi1: {
    id: 'src.pages.Final.rememberLi1',
    defaultMessage: 'Gather any helpful documentation such as bills, receipts, or service expenses.',
  },
  rememberLi2: {
    id: 'src.pages.Final.rememberLi2',
    defaultMessage: 'Review your policy to see what coverages you have.',
  },
  needToKnowLi2: {
    id: 'src.pages.Final.needToKnowLi2',
    defaultMessage: 'There will be no further follow up at this time, but your information will be kept on file in case anything does change.',
  },
  sonnetEconomicalExperience: {
    id: 'src.pages.Final.sonnetEconomicalExperience',
    defaultMessage: 'With over 150 years of experience, we promise you’re in good hands.',
  },
  contact: {
    id: 'src.pages.Final.contact',
    defaultMessage: "We're here to support you throughout this process. If you need to get in touch, call us at 1-844-766-6384.",
  },
  contact1: {
    id: 'src.pages.Final.contact1',
    defaultMessage: "We're here to support you. If you need to get in touch, call us at 1-844-766-6384.",
  },
  backToDashboard: {
    id: 'src.pages.Final.backToDashboard',
    defaultMessage: 'Return to claims dashboard',
  },
  informationSecured: {
    id: 'src.pages.Final.informationSecured',
    defaultMessage: 'Your information is secure.',
  },
});
